export default {"src":"/_next/static/media/instagram.5ce8ee52.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};